// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--nebFI","mobile":"_6c97079b1b--mobile--ogY4H","submit":"_6c97079b1b--submit--HsjAL","info":"_6c97079b1b--info--APHhd"};